// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__qnZsE","infoBtn":"quickbooks_infoBtn__YL7dB","formBox":"quickbooks_formBox__WEbFS","formFooter":"quickbooks_formFooter__2Vu0x"};